import {
  LOAD_CURRENCIES,
  LOAD_PAYMENT_METHODS,
  LOAD_USER_PAYMENT_METHODS,
  LOAD_MY_OFFERS,
  LOAD_MY_ORDERS,
  LOAD_P2PBALANCE,
  LOAD_P2PWALLET,
} from 'redux/actions/p2p';

const initialState = {
  p2pCurrencies: {},
  p2pPaymentMethods: {},
  p2pUserPaymentMethods: [],
  isMyUPMLoading: true,
  myOffers: [],
  isMyOffersLoading: true,
  myOrders: [],
  isMyOrdersLoading: true,
  p2pBalance: [],
  isP2PBalanceLoading: true,
  p2pWalletBalances: [],
  isP2PWalletLoading: true,
};

export const p2pReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CURRENCIES.SUCCESS:
      return {
        ...state,
        p2pCurrencies: action.payload,
      };
    case LOAD_PAYMENT_METHODS.SUCCESS:
      return {
        ...state,
        p2pPaymentMethods: action.payload,
      };

    //* MY PAYMENT METHODS
    case LOAD_USER_PAYMENT_METHODS.STARTED:
      return { ...state, isMyUPMLoading: true };

    case LOAD_USER_PAYMENT_METHODS.SUCCESS:
      return {
        ...state,
        isMyUPMLoading: false,
        p2pUserPaymentMethods: action.payload,
      };

    case LOAD_USER_PAYMENT_METHODS.FAIL:
      return {
        ...state,
        isMyUPMLoading: false,
      };

    //* MY OFFERS

    case LOAD_MY_OFFERS.STARTED:
      return { ...state, isMyOffersLoading: true };
    case LOAD_MY_OFFERS.SUCCESS:
      return {
        ...state,
        isMyOffersLoading: false,
        myOffers: action.payload,
      };
    case LOAD_MY_OFFERS.FAIL:
      return {
        ...state,
        isMyOffersLoading: false,
      };

    //* MY ORDERS

    case LOAD_MY_ORDERS.STARTED:
      return { ...state, isMyOrdersLoading: true };
    case LOAD_MY_ORDERS.SUCCESS:
      return {
        ...state,
        isMyOrdersLoading: false,
        myOrders: action.payload,
      };
    case LOAD_MY_ORDERS.FAIL:
      return {
        ...state,
        isMyOrdersLoading: false,
      };

    //* P2P BALANCE

    case LOAD_P2PBALANCE.STARTED:
      return { ...state, isP2PBalanceLoading: true };
    case LOAD_P2PBALANCE.SUCCESS:
      return {
        ...state,
        isP2PBalanceLoading: false,
        p2pBalance: action.payload,
      };
    case LOAD_P2PBALANCE.FAIL:
      return {
        ...state,
        isP2PBalanceLoading: false,
      };

    //* P2P Wallet Balances

    case LOAD_P2PWALLET.STARTED:
      return { ...state, isP2PWalletLoading: true };
    case LOAD_P2PWALLET.SUCCESS:
      return {
        ...state,
        isP2PWalletLoading: false,
        p2pWalletBalances: action.payload,
      };
    case LOAD_P2PWALLET.FAIL:
      return {
        ...state,
        isP2PWalletLoading: false,
      };

    default:
      return state;
  }
};
